var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "phone-edit-modal",
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.requestCode($event)
        }
      }
    },
    [
      _vm._m(0),
      _c(
        "div",
        { staticClass: "edit-form" },
        [
          _c("ui-input", {
            staticClass: "input",
            attrs: {
              clearable: "",
              mask: "phone",
              validate: "phone",
              label: "Телефон*",
              placeholder: "+7 (***) ***-**-**",
              error: _vm.phoneError
            },
            model: {
              value: _vm.phone,
              callback: function($$v) {
                _vm.phone = $$v
              },
              expression: "phone"
            }
          }),
          _vm.codeRequested
            ? _c("ui-input", {
                ref: "code",
                staticClass: "input",
                attrs: {
                  readonly: _vm.code.length === 6,
                  error: _vm.error,
                  mask: "code",
                  label: "Код*",
                  placeholder: "Введите код из SMS"
                },
                model: {
                  value: _vm.code,
                  callback: function($$v) {
                    _vm.code = $$v
                  },
                  expression: "code"
                }
              })
            : _vm._e(),
          _vm.codeRequested
            ? _c(
                "div",
                { staticClass: "status" },
                [
                  _vm.retryTimeoutSeconds
                    ? [
                        _vm._v(
                          "\n        Повторная отправка возможна через " +
                            _vm._s(_vm.retryTimeout) +
                            "\n      "
                        )
                      ]
                    : _vm.codeRequested
                    ? [
                        _c("span", { on: { click: _vm.requestCode } }, [
                          _vm._v("\n          Отправить код повторно\n        ")
                        ])
                      ]
                    : _vm._e()
                ],
                2
              )
            : _vm._e(),
          _c("ui-button", {
            class: ["submit", { codeRequested: _vm.codeRequested }],
            attrs: {
              wide: "",
              type: "submit",
              disabled: _vm.disabledButton,
              text: _vm.codeRequested ? "Изменить" : "Получить код"
            }
          })
        ],
        1
      ),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _vm.isLoading
            ? _c("ui-loader", { staticClass: "loader", attrs: { size: "60" } })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _vm._v("\n    Изменение телефона\n    "),
      _c("span", [
        _vm._v(
          "\n      На указанный номер будет отправлен код подтверждения\n    "
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }